"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1799))
 * @lastsynced 2026-10-29T13:52:49.724Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const PriceTagDollar = createSVGIcon(
  <path
    d="m14.262 12.572-1.985-1.985a1.108 1.108 0 0 0-1.686 0c-.925.924 1.2 4.46.272 5.384a1.17 1.17 0 0 1-1.687 0l-1.985-1.985m5.655-2.83 1.06-1.061m-6.363 6.363 1.06-1.06M17.504 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM.855 12.646a1.207 1.207 0 0 0 0 1.708l8.792 8.792a1.207 1.207 0 0 0 1.708 0l11.439-11.439A2.42 2.42 0 0 0 23.5 10V1.5a1 1 0 0 0-1-1H14a2.41 2.41 0 0 0-1.707.707z"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "PriceTagDollar",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
